import { SampleTypeEnum } from "../enums/sampleType.enum";

export class CalibrationEquipmentOwner {
    calibrationEquipmentId: string;
    ownerUserId: string;
    ownerUserName: string;
    ownerFullName: string;
    ownerEmail: string;
    dateCreated: string;
}

export class CalibrationEquipment {
    id: string;
    name?: string;
    modelNumber: string;
    serialNumber: string;
    manufacturer: string;
    dateAcquired: string;
    status: number;
    lastCalibrated: string;
    calibrationDue: string;
    createdByUserId: string;
    organizationLevelId: string;
    equipmentCode: string;
    calibrationFrequency: number;
    uuid: string;
    sampleType: SampleTypeEnum;
    notifyBeforeDueDays?: number;
    owners?: CalibrationEquipmentOwner[] = [];
    ownerUserIds?: string[] = []; // transient field for multi-select binding
    lastDueSoonNotificationSentAt?: string;
}
